import React from 'react'
import Helmet from 'react-helmet'
import Layout from '../../components/layout'
import PageBannerImage from '../../components/PageBannerImage'
import PageBannerText from '../../components/PageBannerText'
import OzonePurificationBanner from '../../images/products/Benefits_OzonePoolSystem_HD_411x192.png'
// Placeholder for the main banner - Update this path to your actual banner
import MagnesiumBanner from '../../images/Magnesium_Pool_Landing_Page_for_Mineral_Swim_V3.jpg'
import { Link } from 'gatsby'
import Holder from '../../images/image.png'
const MagnesiumPoolPage = () => (
	<Layout style={{ paddingBottom: '1rem' }}>
		<Helmet>
			<meta charSet="utf-8" />
			<title>Mineral Generator Advantages: Elevate Your Pool Experience | MineralSwim</title>
			<meta
				name="description"
				content="Natures most powerful sanitiser. Up to 3000x more powerful than other sanitation methods & reduces chlorine needs up to 80%. Minerals in the water have many health benefits and is suitable for sensitive skin. "
			/>
			<meta
				name="keywords"
				content="mineral pool Generator, mineral generator"
			/>
			<link rel="canonical" href="https://mineralswim.com/benefits/magnesium-pool/" />
		</Helmet>
		<main  className="bg-white relative">
        <header className='w-screen absolute main-page-header bg-center z-10'
						>
							<div className='mx-auto max-w-screen-xl h-full grid grid-cols-6 lg:grid-cols-12 lg:py-10 px-5 md:px-10'>						
							<div className='hidden lg:flex col-span-6'></div>
								<div className='text-center lg:text-left col-span-6 h-full flex flex-col justify-center md:gap-5 lg:gap-0'>
								<div className='bg-white bg-opacity-40 p-5 rounded-2xl '>
									<h1 className='text-black text-2xl md:text-4xl font-semibold'>Magnesium Pool</h1>
									<div className='flex w-full justify-center items-center lg:justify-start'>
									<div className='w-20 md:w-16 h-1 mb-4 mt-4 md:mt-2 border-2 border-black'/>	
									</div>
									<p className='text-black md:text-base leading-6'>Experience the next evolution in swimming pool wellness. A Magnesium Pool powered by Mineral Swim™ combines the therapeutic benefits of Dead Sea minerals with the gentle, effective sanitising power of Ozone purification - delivering crystal-clear water that’s healthier for you, your skin, and the planet.
										</p>				
										<div className='w-full flex justify-center lg:justify-start mt-7 md:mt-10'>			              
										<Link to="/s/?page=how-it-works">             
									<p className='text-white text-base font-bold bg-gray-800 px-8 rounded-lg py-1 hover:bg-gray-200 hover:text-black cursor-pointer uppercase'>Learn more</p>	
									</Link>			
									</div>	
									</div>								
									</div>                
							</div>
								</header>
				<div className='top-0 bg-cover bg-right lg:bg-center z-0' style={{
                backgroundImage: `url(${MagnesiumBanner})`,
								backgroundAttachment: 'fixed',
								position: 'relative',
								height: '90vh',
            }}
						data-scroll
      data-scroll-speed="-10"
						>
							
								</div>
								<div className='relative -mt-24 md:-mt-24 lg:-mt-40 pt-40 pb-20 bg-white z-10'>
				<section  id="main-content" className="max-w-screen-xl font-display text-base mx-auto mb-20 text-justify md:text-left px-8 md:px-10 grid grid-cols-1 md:grid-cols-2 gap-10">
		<div className='h-full w-full flex flex-col justify-center gap-4'>
					<h3 className='text-2xl font-bold text-left'>Transform Your Pool into a Natural Oasis with Mineral Swim™</h3>
					<div>
					<div className='w-20 md:w-16 h-1 mt-4 md:mt-2 border-2 border-blue-500'/>
					</div>

					<p>Experience the next evolution in swimming pool wellness. A Magnesium Pool powered by Mineral Swim™ combines the therapeutic benefits of Dead Sea minerals with the gentle, effective sanitising power of Ozone purification - delivering crystal-clear water that’s healthier for you, your skin, and the planet.
                    </p>
					</div>
					<img src={OzonePurificationBanner} alt='EcoFriendly' className='w-full h-72 border object-cover rounded-2xl'/>	
                    <div className='h-full w-full flex flex-col justify-center gap-4'>
					<h3 className='text-2xl font-bold text-left'>Why Choose a Magnesium Pool?</h3>
					<div>
					<div className='w-20 md:w-16 h-1 mt-4 md:mt-2 border-2 border-blue-500'/>
					</div>

					<p> 
					<ul className='flex flex-col py-4 gap-4'>
					<li>
						<h4 className='text-xl font-semibold mb-2'>Gentle on Skin, Hair & Eyes</h4>
						<p>Unlike traditional chlorine pools, a Magnesium Pool is soothing and non-irritating. Magnesium-enriched water naturally softens and hydrates your skin, leaving it feeling smooth and refreshed after every swim.
                        </p>
						</li>
					<li>
						<h4 className='text-xl font-semibold mb-2'>100% Natural Purification
                        </h4>
						<p>Mineral Swim™ harnesses Ozone purification technology to destroy impurities, bacteria, and organic matter - reducing the need for harsh chemicals while keeping your pool water cleaner for longer.</p>
						</li>
					<li>
						<h4 className='text-xl font-semibold mb-2'>Health & Wellness Benefits</h4>
						<p>Enjoy the calming and restorative effects of Magnesium, known to relax muscles, reduce stress, and improve sleep quality. It’s like bringing the benefits of a day spa into your own backyard.
                        </p>
					</li>

                    <li>
						<h4 className='text-xl font-semibold mb-2'>Eco-Friendly & Sustainable
                        </h4>
						<p>With fewer chemicals, reduced water wastage, and energy-efficient operation, Magnesium Pools ar	e a sustainable choice for eco-conscious homeowners who care about their health and the environment.
                        </p>
					</li>
					</ul>
                    </p>
					</div>	
					{/* <img src="https://storage.googleapis.com/sales-audit.appspot.com/12353947297environmentallyfriendlysystem_image.jpg?GoogleAccessId=firebase-adminsdk-b0ru6%40sales-audit.iam.gserviceaccount.com&Expires=4102444800&Signature=jpQiwQv1ZhsEDMQVOEi2pet2ay50UT2yBU1nqBebfQipdKJtSAbLCKKP%2FW5drMD4Gu%2BzLqlbq7Ke2UQWt6vtmxMCGt%2BKvPprYADpriBftwkFU%2BJMVXp%2Bg9JtqL4ACMz%2F%2F%2B9Begn2ok7ji903hRGrsk1MWRpZ1TH98dj%2BVud%2FqIElXPY%2B0m1tV6tavegB%2BlWj0t4SbKbpIbtZAY5jpnLrlQfHsqeClo99YDbpS24naSC91S%2FLHVBIH7iW7mU5MjtrXHZQw00%2FH4GCQ8eoICfGmdK8dqsxdegDCBdPXSknaxQkAyKysjqIIHaIilN6QrlkrjjtjFANn80hF%2Fj3L0Lpew%3D%3D" alt='Environtment Friendly' className='w-full h-72 border object-cover rounded-2xl'/>								 */}
				<div></div>
		<div className='h-full w-full flex flex-col justify-center gap-4'>
					<h3 className='text-2xl font-bold text-left'>The Mineral Swim™ Difference</h3>
					<div>
					<div className='w-20 md:w-16 h-1 mt-4 md:mt-2 border-2 border-blue-500'/>
					</div>

					<p>
                    <ul className="list-disc pl-5 space-y-4 marker:text-blue-500">
                                <li className="text-base">
                                    <strong>100% Dead Sea Minerals</strong> – sourced from the world's most therapeutic body of water
                                </li>
                                <li className="text-base">
                                    <strong>Advanced Ozone-to-Oxygen Purification system</strong> – for cleaner, clearer, and safer pool water
                                </li>
                                <li className="text-base">
                                    <strong>Proven compatibility</strong> with most existing pool systems and chlorinators
                                </li>
                                <li className="text-base">
                                    <strong>Made in Australia</strong> – Manufactured, designed and supported – proudly brought to you by Maytronics
                                </li>
                            </ul>



                    </p>
					</div>
					<img src="https://storage.googleapis.com/sales-audit.appspot.com/52749839744maintainingyourmineralpool_image.jpg?GoogleAccessId=firebase-adminsdk-b0ru6%40sales-audit.iam.gserviceaccount.com&Expires=4102444800&Signature=PxAZlqPEko1ionVgY%2BpuAPb%2Fmz%2Fh8EuSMrkGWxd06HWDhZvJL58%2Bp4BGCvJ%2F1nTBJI3XPrQ0kAmETt0ejHy%2FqwEN2KPVULEvLrOYLTvYc8yQiPDUm%2FaklhBtfqnavrmB3bX8LM1dVnQYA6UeXeDe6r6PZcbcTuJtcvCGEHmQ4VlKVXPabZs0HBmjZ8vM1C3bVejB%2FUh4AY7l6ejzYbXIdyzCGzjRD%2Bg71gZG1NDijbovcbus2oFb2PNvB6OmJa5xiBEO4dCOcGLFj50XGJ5LcGNN7OVciGANonZPDSe3v3W%2BO2Y5Ya0AnpZVb0YC2p5jCaIcqqLyPY7EjAGy6bMxJg%3D%3D" alt='Maintain Your Mineral Pool' className='w-full h-72 border object-cover rounded-2xl'/>	
		<div className='h-full w-full flex flex-col justify-center gap-4'>
					<h3 className='text-2xl font-bold text-left'>Make the Switch to Mineral Swim™ Today</h3>
					<div>
					<div className='w-20 md:w-16 h-1 mt-4 md:mt-2 border-2 border-blue-500'/>
					</div>

					<p>Transform your pool into a luxurious, mineral-rich sanctuary. Whether you’re building a new pool or upgrading an existing one, Mineral Swim™ is the smarter, healthier, and more natural choice for Australian families.
                    </p>
					</div>
                   <div></div>

				</section>
				<div className="flex flex-col sm:flex-row gap-4 items-center justify-center lg:flex-1 font-display text-base font-semibold uppercase">
					<Link
					to="/benefits"
									className="cursor-pointer flex items-center justify-center  w-48 py-1 border border-transparent rounded-md shadow-sm text-base font-medium text-gray-800 bg-gray-100 hover:bg-gray-300 whitespace-nowrap"
								>
									Back to Benefits
								</Link>
						<Link
							to="https://www.maytronics.com.au/shop?brand=Mineral%2520Swim"
							className="whitespace-nowrap inline-flex items-center justify-center w-48 py-1 border border-transparent rounded shadow-sm bg-blue-500 hover:bg-blue-400 text-white"
						>
							Explore Products
						</Link>
					</div>
				</div>
				</main>
	</Layout>
)

export default MagnesiumPoolPage